// Check if code is running in a browser environment
export const isBrowser = typeof window !== "undefined";

// Check if code is running in development environment
export const isDevelopment = import.meta.env.DEV;

// Check if code is running in production environment
export const isProduction = import.meta.env.PROD;

// Check if code is running on the server (opposite of isBrowser)
export const isServer = !isBrowser;
